import axios from "axios";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import Url from "../../Url";
import { emailOtpGenerationDetails, emailOtpGenerationValue } from "./Model";
import { headers } from "../../components/Utility";

type InitialState = {
  loading: boolean;
  emailOtpGenerationRes: emailOtpGenerationValue;
  successMsg: string;
  errorMsg: string;
  status: 0;
};
const initialState: InitialState = {
  loading: false,
  emailOtpGenerationRes: {} as emailOtpGenerationValue,
  successMsg: "",
  errorMsg: "",
  status: 0,
};

export const emailOtpGeneration = createAsyncThunk<
  emailOtpGenerationValue,
  emailOtpGenerationDetails
>(
  "emailOtpGeneration/emailOtpGeneration",
  async (payload: emailOtpGenerationDetails, { rejectWithValue }) => {
    return await axios
      .post(Url.apiURL + "/patientapp/email-otp-generation/", payload, {
        headers,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) =>
        rejectWithValue(
          error.response.data.non_field_errors[0] ||
            error.response.message ||
            "Something went wrong"
        )
      );
  }
);

const emailOtpGenerationSlice = createSlice({
  name: "emailOtpGeneration",
  initialState,
  reducers: {
    updateEmailOtpGenerationResMsg: (state) => {
      state.successMsg = "";
      state.errorMsg = "";
    },
    clearEmailOtpGenerationAPIRes: (state) => {
      state.successMsg = "";
      state.errorMsg = "";
      state.emailOtpGenerationRes = {} as emailOtpGenerationValue;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(emailOtpGeneration.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      emailOtpGeneration.fulfilled,
      (state, action: PayloadAction<emailOtpGenerationValue>) => {
        state.loading = false;
        state.emailOtpGenerationRes = action.payload;
        state.successMsg = action.payload.message;
        state.errorMsg = "";
      }
    );
    builder.addCase(emailOtpGeneration.rejected, (state, action) => {
      state.loading = false;
      state.emailOtpGenerationRes = {} as emailOtpGenerationValue;
      state.successMsg = "";
      state.errorMsg = String(action.payload!);
    });
  },
});
export const { updateEmailOtpGenerationResMsg, clearEmailOtpGenerationAPIRes } =
  emailOtpGenerationSlice.actions;
export default emailOtpGenerationSlice.reducer;
